import { render, staticRenderFns } from "./AppBibleBookOpen.vue?vue&type=template&id=5d879268&"
import script from "./AppBibleBookOpen.vue?vue&type=script&lang=js&"
export * from "./AppBibleBookOpen.vue?vue&type=script&lang=js&"
import style0 from "./AppBibleBookOpen.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports